// extracted by mini-css-extract-plugin
module.exports = {"root":"toastContainer_root__VpzFO bottom-0 fixed gap-y-xs grid mb-xs min-w-full z-toast lg_min-w-auto lg_right-md"};